/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReturnSelettivaDto } from '../../models/return-selettiva-dto';
import { SelettivaAddVvfTrentoDto } from '../../models/selettiva-add-vvf-trento-dto';

export interface ApiAerotalkAlertcallPost$Params {
    /**
     * Dati della selettiva
     */
    body: SelettivaAddVvfTrentoDto;
}

export function apiAerotalkAlertcallPost(
    http: HttpClient,
    rootUrl: string,
    params: ApiAerotalkAlertcallPost$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<ReturnSelettivaDto>> {
    const rb = new RequestBuilder(rootUrl, apiAerotalkAlertcallPost.PATH, 'post');
    if (params) {
        rb.body(params.body, 'application/json');
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<ReturnSelettivaDto>;
        }),
    );
}

apiAerotalkAlertcallPost.PATH = '/api/aerotalk/alertcall';
